<template>
    <div>
        <b-row>
            <b-col sm="8">
                <h5 class="heading-1 mb-4">
                    <span>Ação</span>
                </h5>
            </b-col>
            <b-col sm="4">
                <b-button class="float-right" variant="warning" @click="voltarAcao()">
                    <i class="fa fa-history"></i>
                    Voltar as ações
                </b-button>
            </b-col>
        </b-row>
        <app-erros-box :erros="erros" v-if="erros.length > 0"></app-erros-box>
        <b-alert show>
            <b-row>
                <b-col>
                    Nome da ação:
                    <strong>
                        {{ acao.nomeAcao }}
                    </strong>
                    <br />
                    Gestor de Execução:
                    <strong>
                        {{ acao.nomeGestor }}
                    </strong>
                    <br />
                    Unidade:
                    <strong>
                        {{ acao.nomeUnidade }}
                    </strong>
                    <br />
                    Situação:
                    <app-status :status="acao.situacao">
                    </app-status>
                </b-col>
            </b-row>
        </b-alert>
        <b-card no-body>
            <b-card-header>
                <b-row>
                    <b-col>
                        <span class="h5"> Metas </span>
                    </b-col>
                    <!-- <b-col
                        sm="4">
                        <btn-inserir-evento
                            class="float-right mb-2"
                            v-if="acao.codSituacao != 1"
                            :tipo="operacao"
                            :acao="acao"
                            @inserirEvento="inserirEvento($event)"
                            @atualizarErros="atualizarErros($event)"
                            @atualizarLista="atualizarEventos()"
                        ></btn-inserir-evento>
                    </b-col> -->
                </b-row>
            </b-card-header>
            <b-card-body>
                <div>
                    <b-row>
                        <b-col>
                            <h5 class="heading-1 mb-4">
                                <span>Eventos</span>
                            </h5>
                        </b-col>
                    </b-row>

                    <eventos-tabela :eventos="eventos" :operacao="operacao" :acao="acao"
                        @atualizarEvento="atualizarEvento($event)" @cancelarEvento="cancelarEvento($event)">
                        <template slot="botoes"> </template>
                    </eventos-tabela>
                    <b-row>
                        <b-col>
                            <h5 class="heading-1 mb-4">
                                <span>Consultorias</span>
                            </h5>
                        </b-col>

                    </b-row>
                    <consultorias-tabela :consultorias="consultorias" :operacao="operacao" :acao="acao"
                        @atualizarConsultoria="atualizarConsultoria($event)"
                        @cancelarConsultoria="cancelarConsultoria($event)">
                        <template slot="botoes"> </template>
                    </consultorias-tabela>
                </div>
            </b-card-body></b-card>
    </div>
</template>

<script>
import EventosTabela from './EventosTabela'
import ConsultoriasTabela from './ConsultoriasTabela'
import BtnInserirEvento from './BtnInserirEvento'
import ConveniosServicos from '../../../ConveniosServicos'

export default {
    components: {
        EventosTabela,
        ConsultoriasTabela,
        BtnInserirEvento
    },

    props: {
        convenio: {
            type: Object,
            default: () => { }
        },

        acao: {
            type: Object,
            default: () => ({})
        },
        consultorias: {
            type: Array,
            default: () => []
        },

        eventos: {
            type: Array,
            default: () => []
        }
    },

    data() {
        return {
            operacao: 'D',
            erros: [],
        }
    },

    methods: {
        cancelar() {
            this.operacao = 'D'
        },

        voltarAcao() {
            this.operacao = 'D'
            this.$emit('voltarAcao', null)
        },

        voltarEAtualizar() {
            this.$emit('atualizarAcao', null)
            this.$emit('voltarAcao', null)
        },

        confirmarSalvar() {
            this.$swal({
                title: 'Rateios',
                html: `Confirma as alterações no rateio?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.salvarEvento()
                }
            })
        },

        salvarEvento() {
            this.$store.dispatch('addRequest')
            let eventoDto = {
                idAcaoPlanoTrabalho: this.acao.idAcaoPlanoTrabalho,
                nomeEvento: this.evento.nomeEvento,
                codEvento: this.evento.codEvento
            }
            ConveniosServicos.salvarEvento(eventoDto)
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Evento inserido com Sucesso!',
                                'OK',
                                this.$toastConfig.success)
                            this.$emit(
                                'atualizarAcao',
                                response.data)
                            this.operacao = 'D'
                        } else {
                            this.$toast.error(
                                'Falha ao inserir Evento!',
                                'ERRO',
                                this.$toastConfig.error)
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
                )
        },

        atualizarEventos() {
            this.$store.dispatch('addRequest')
            ConveniosServicos.obterEventosPorAcao(
                this.acao.idAcaoPlanoTrabalho)
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.eventos = response.data
                        } else {
                            this.$toast.error(
                                'Erro ao obter os eventos da ação.',
                                'ERRO',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        },
        atualizarConsultorias() {

            this.$store.dispatch('addRequest')

            this.dataServicos.obterConsultoriasPorAcao(
                this.acao.idAcaoPlanoTrabalho)
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.consultorias = response.data
                            
                        } else {
                            this.$toast.error(
                                'Erro ao obter os consultorias da ação.',
                                'ERRO',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        },

        atualizarErros(eventos) {
            this.erros = eventos;
        },
    },
}
</script>
